/*
 * @Author: Teemo Ding
 * @Date: 2021-06-24 13:17:54
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-30 17:06:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/StoreDetails/config.ts
 */

const optionsList = ({ getI18n }) => [
  { label: getI18n('storeDetailsSetting.detail.beauty'), value: 'beauty' },
  { label: getI18n('storeDetailsSetting.detail.clothing'), value: 'clothing' },
  {
    label: getI18n('storeDetailsSetting.detail.electronics'),
    value: 'electronics',
  },
  {
    label: getI18n('storeDetailsSetting.detail.furniture'),
    value: 'furniture',
  },
  {
    label: getI18n('storeDetailsSetting.detail.handcrafts'),
    value: 'handcrafts',
  },
  { label: getI18n('storeDetailsSetting.detail.jewelry'), value: 'jewelry' },
  { label: getI18n('storeDetailsSetting.detail.painting'), value: 'painting' },
  {
    label: getI18n('storeDetailsSetting.detail.photography'),
    value: 'photography',
  },
  {
    label: getI18n('storeDetailsSetting.detail.restaurants'),
    value: 'restaurants',
  },
  {
    label: getI18n('storeDetailsSetting.detail.grocerices'),
    value: 'grocerices',
  },
  {
    label: getI18n('storeDetailsSetting.detail.otherfood&drink'),
    value: 'Other food & drink',
  },
  { label: getI18n('storeDetailsSetting.detail.sports'), value: 'sports' },
  { label: getI18n('storeDetailsSetting.detail.toys'), value: 'toys' },
  { label: getI18n('storeDetailsSetting.detail.services'), value: 'services' },
  {
    label: getI18n('storeDetailsSetting.detail.virtualServices'),
    value: 'virtualServices',
  },
  { label: getI18n('storeDetailsSetting.detail.other'), value: 'other' },
  {
    label: getI18n('storeDetailsSetting.detail.ihaven’tdecidedyet'),
    value: 'I haven’t decided yet',
  },
];
const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('settings.list.storeDetails'),
  },
];
export { breadcrumbData, optionsList };
